var render, staticRenderFns
import script from "./position_information.vue?vue&type=script&lang=js"
export * from "./position_information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('862344ae')) {
      api.createRecord('862344ae', component.options)
    } else {
      api.reload('862344ae', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/position_information/position_information.vue"
export default component.exports